import(/* webpackMode: "eager" */ "/app/src/components/account-components/account/account.component.tsx")